
import React from "react";
import { SettingsTemplate } from "../templates/Settings";

export const Settings: React.FC = () => {
  return (
    <SettingsTemplate />
  );
}